import { browserApi } from 'lib/httpClient';
import { browserLogger } from 'utils/logger/browserLogger';
import { getErrorDetails } from 'utils/getErrorDetails';
import { ParsedThreeDsData } from 'types/threeds';

export async function getThreeDsData(
  transactionReference: string,
  owner: 'bileto' | 'platform'
): Promise<ParsedThreeDsData | null> {
  const logger = browserLogger();

  try {
    const { data } = await browserApi.get<ParsedThreeDsData>(`/three-ds`, {
      params: {
        transactionReference,
        owner
      }
    });

    if (!data || !data.pspReference || !data.resultCode) {
      throw new Error('Invalid ThreeDS data received');
    }

    return data;
  } catch (error) {
    const errorDetails = getErrorDetails(error);

    logger.error(
      {
        message: '[DiscoveryNext][3DS] Error fetching ThreeDS data',
        data: { transactionReference },
        extra: {
          transactionReference,
          owner,
          error: {
            message: errorDetails.message,
            stack: errorDetails.stack
          }
        }
      },
      'getThreeDsData'
    );

    return null;
  }
}
